import './App.css';
import Home from './components/Home/Home';
import { GlobalProvider } from './context/GlobalProvider';

type AppProps = {
  rtl: boolean;
}

function App(props: AppProps) {
  return (
    <GlobalProvider >    
      <Home {...props}/>
    </GlobalProvider>
  );
}

export default App;
